import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import React from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import useTranslation from '../../useTranslation';
import type { WidgetFC, WidgetProps } from '../Widget/types';

interface Props extends WidgetProps {
  /**
   * The text key that will be used as title in header.
   */
  titleTextKey: string;
}

/**
 * Generic widget to use as header title.
 *
 * @author Antony Lescano
 */
const HeaderWidget: WidgetFC<Props> = ({ titleTextKey }) => {
  const cx = useClassNameMapper();
  const { formatMessage } = useTranslation(EndUserComponent.HEADER_WIDGET);

  return (
    <header
      className={cx(
        'd-flex flex-column flex-sm-row align-items-sm-center justify-content-center text-center'
      )}
    >
      <h1 className={cx('lia-g-mb-0 lia-g-mr-sm-20')}>{formatMessage(titleTextKey)}</h1>
    </header>
  );
};

export default HeaderWidget;
